/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserCompanyMyGroupCto } from '../../models/user-company-my-group-cto';

export interface GetTeams$Json$Params {
  companyGuid?: string;
  teamName?: string;
}

export function getTeams$Json(http: HttpClient, rootUrl: string, params?: GetTeams$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserCompanyMyGroupCto>>> {
  const rb = new RequestBuilder(rootUrl, getTeams$Json.PATH, 'get');
  if (params) {
    rb.query('companyGuid', params.companyGuid, {});
    rb.query('teamName', params.teamName, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<UserCompanyMyGroupCto>>;
    })
  );
}

getTeams$Json.PATH = '/design/team';
